export default {
  methods: {
    /**
     * Scale the metricTitle element to fit the Container
     */
    scaleText({ elementName, maxFontSize }) {
      let newTextScale = 1
      const currentTextWidth = this.textDimensions(elementName, maxFontSize).textWidth
      const containerWidth = this._getContainerWidth(elementName)

      if (containerWidth > currentTextWidth) {
        this.updateTextSize(elementName, maxFontSize)
        return
      }

      // Scale text to match the actual container size
      newTextScale *= containerWidth / currentTextWidth
      const newFontSize = parseInt(maxFontSize, 10) * newTextScale - 1

      this.updateTextSize(elementName, newFontSize)
    },

    /**
     * Sets the font size to zero, to get the originally available container width
     */
    _getContainerWidth(elementName) {
      this.updateTextSize(elementName, 0)
      return (
        this.$refs[elementName].parentElement.getBoundingClientRect().width -
        parseInt(window.getComputedStyle(this.$refs[elementName].parentElement).marginLeft, 10) -
        parseInt(window.getComputedStyle(this.$refs[elementName].parentElement).marginRight, 10)
      )
    },

    /**
     * Update the font size of the text element in the DOM
     */
    updateTextSize(elementName, newFontSize) {
      this.$refs[elementName].style['font-size'] = `${newFontSize}px`
    },
    /**
     * Get the full width of the element
     */
    textDimensions(elementName, maxFontSize) {
      this.$refs[elementName].style['font-size'] = `${maxFontSize}px`
      const textWidth = this.$refs[elementName].scrollWidth
      const textHeight = this.$refs[elementName].scrollHeight
      return {
        textWidth,
        textHeight,
      }
    },
  },
}
